import Vue from 'vue'
import VueShortkey from 'vue-shortkey'
import App from './App.vue'
import '@/mixins/helperMixin.js'
import '@/mixins/alertMixin.js'
import '@/global/filters.js'
import '@/mixins/authorizationMixin.js'

Vue.config.productionTip = false
Vue.use(VueShortkey)

new Vue({
  render(h) {
    return h(App)
  },
}).$mount('#app')
